<ng-container *transloco="let _t">

<div class="header-suppl">
	<mat-chip-list>
		<mat-chip *ngFor="let year of yearBar" 
			mat-list-item (click)="load(year)"
			[ngClass]="{'mat-accent':year==currentYear}"> 
				{{year}}
		</mat-chip>
	</mat-chip-list>
</div>

<!--
<div class="row nav-chart">
	<div class="col-4" *ngIf="fullPage && currentSheet!=null">
		<h3>{{ _t('statistics-stats-h3-0') }}</h3>
		<mat-chip-list>
		  <mat-chip *ngFor="let year of yearBar" 
		  	mat-list-item (click)="load(year)"
		  	[ngClass]="{'mat-accent':year==currentYear}"> 
		  		{{year}}
		  </mat-chip>
		</mat-chip-list>
	</div>
	<statistics-linechart #linechart *ngIf="data.length>0"
		class="chart" 
		[ngClass]="{'col-8': fullPage, 'offset-2': fullPage,
		'inclueded': !fullPage}"
		[fullPage]="fullPage">
	</statistics-linechart>
</div>
-->




<!-- table head : monthes -->
<table>
  <tr class="head">
	  <th class="chart-btn"><button mat-mini-fab color="secondary"
	[title]="_t('statistics-stats-title-0')" 
	(click)="removeAllChart()" class="tglch">
	<mat-icon>not_interested</mat-icon>
</button></th>
  	<th class="label">Statistiques de l'année {{currentYear}}</th>
  	<th class="month" *ngFor="let month of monthes; let m=index">
  		<strong>{{month}}</strong></th>
  	<th class="line-total"><strong class="bigger">{{ _t('statistics-stats-strong-1') }}</strong></th>
  	
</table>

<div (keyup)="changeFocus($event);" class="tables">
<!--categories-->
<div *ngFor="let parent of parentStatCats; let p=index;">
  <div *ngIf="parent!=undefined">
	<table [ngClass]="{opened:showChild[p]}"
		class="opened-show-child mat-elevation-z8 table-bordered table-striped">
	  <tr>
		<td class="chart-btn"><button mat-mini-fab color="disabled" [id]="'tglch-'+p" 
			[title]="_t('statistics-stats-title-1')" 
			(click)="toggleChart(p)" class="tglch">
			<mat-icon>timeline</mat-icon>
		</button></td>
	  	<td class="label parent" (click)="toggleChild(p);">{{parent}}
	  		<mat-icon>arrow_drop_down</mat-icon></td>
	  	<td class="month" *ngFor="let month of monthes; let m=index">
	  		<strong class="big" *ngIf="!showChild[p]">{{totalMonth(p, m)}}</strong>
	  	</td>
	  	<td class="line-total"><strong class="bigger" *ngIf="!showChild[p]">{{totalCat(p)}}</strong></td>
	  	
	  </tr>

	  <!--subcategories-->
	  <tbody *ngFor="let cat of childStatCats[p]; let c=index"
	  	[hidden]="!showChild[p]">
		  <tr *ngIf="cat!=undefined">
			<td class="chart-btn"><button mat-mini-fab color="disabled" [id]="'tglch-'+c"
				[title]="_t('statistics-stats-title-1')" 
				(click)="toggleChart(c)" class="tglch">
				<mat-icon>timeline</mat-icon>
				</button></td>
		  	<td class="label"><strong>{{cat}}</strong></td>
		    <td class="month" *ngFor="let month of monthes; let m=index">
		      <input matInput *ngIf="currentBuilding!=0"
		      [id]="c+'-'+m" type="number" 
		      [(ngModel)]="data[c][m]" [value]="data[c][m]"
		      (focus)="$event.target.select()" (blur)="onBlur($event)" />
		      <span *ngIf="currentBuilding==0">{{data[c][m]}}</span>
		    </td>
		    <td class="line-total"><strong class="big">{{totalYear(c)}}</strong></td>
		    
		  </tr>
	  </tbody>
	  <tr [hidden]="!showChild[p]">
		<td class="chart-btn"></td>
	  	<td class="label"><strong class="big">{{ _t('statistics-stats-strong-6') }}</strong></td>
	  	<td class="month" *ngFor="let month of monthes; let m=index">
	  		<strong class="big">{{totalMonth(p, m)}}</strong>
	  	</td>
	  	<td class="line-total"><strong class="bigger">{{totalCat(p)}}</strong></td>
	  </tr>
	</table>
	</div>
</div>

</div>
<!--
<p><br></p>
-->
<div class="row nav-chart">
	<statistics-linechart #linechart *ngIf="data.length>0"
		class="chart" 
		[ngClass]="{'col-8': fullPage, 'offset-2': fullPage,
		'inclueded': !fullPage}"
		[fullPage]="fullPage">
	</statistics-linechart>
</div>
</ng-container>